module.exports = __webpack_public_path__ + "assets/img/Novo_Grocery Shop_RGB_hr.fcba6d51.png";